import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import { Title } from '../../components/title/title';
import { ResultadoValido } from './valido';
import { ResultadoInvalido } from './invalido';
import { useGetExemploByIdService } from '../../hooks/certificado';
import { BaSeLoading } from '@base/react';
import { ResultContent } from './resultado-styled';
import { Helmet } from 'react-helmet';

const ROBOTS_META_CONTENT = 'noindex, nofollow, noarchive, nosnippet';

export const Resultado = () => {
  const { getRouteParam } = Sebrae.useRouter();
  const id = getRouteParam('id');
  const [certificado, loading] = useGetExemploByIdService(id);
  // eslint-disable-next-line
  const [metaContent, setMetaContent] = React.useState(ROBOTS_META_CONTENT);
  return (
    <div>
      <Helmet>
        <meta name="robots" content={metaContent} />
      </Helmet>
      <Title
        titulo="Cursos Sebrae"
        subtitulo="Validação de certificado"
        paddingContent="16px"
        paddingSubtitulo="16px"
      />
      {!loading ? (
        <ResultContent>
          {certificado && !certificado.erro ? (
            <ResultadoValido certificadoDetalhes={certificado} />
          ) : (
            <ResultadoInvalido />
          )}
        </ResultContent>
      ) : (
        <div style={{ paddingTop: 100 }}>
          <BaSeLoading
            lightMode="default"
            shadowLevel={0}
            spinnerSize={24}
            text="Buscando certificado..."
          />
        </div>
      )}
    </div>
  );
};
